import React, { useState, useEffect, useRef } from 'react';
import postscribe from 'postscribe';

import Spinner from '../../components/Spinner';

const token = `${process.env.RUKA_ES_AUTH_TOKEN}`;

const refreshSetting = parseInt(drupalSettings.panoraama_refresh_interval);

const fetchUrl = `${process.env.NODE_API_URL}/getPanoraamaContent?url=${drupalSettings.panoraama_url}`;

const PanoraamaContent = () => {
  const advRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getPanoraamacontent() {
      await fetchApi();
    }

    getPanoraamacontent();
  }, []);

  // Content is fetched every x minutes, can be changed in site settings.
  // Minimum one minute.
  useEffect(() => {
    async function getPanoraamacontent() {
      await fetchApi();
    }

    let refreshInterval = refreshSetting * 60000;
    if (!refreshInterval || refreshInterval < 60000) {
      refreshInterval = 60000;
    }

    const interval = setInterval(() => {
      getPanoraamacontent();
      // Previous content needs to be removed.
      document.getElementById('panoraama-content-react').innerHTML = null;
    }, refreshInterval);

    return () => clearInterval(interval);
  }, []);

  async function fetchApi() {
    console.log('Fetching content from Panoraama');
    setIsLoading(true);

    const response = await fetch(fetchUrl, {
      headers: {
        token: token,
      },
    });

    if (response.ok) {
      const pageContent = await response.text();
      // Postscribe is used, because panoraama script uses document.write,
      // and otherwise the whole page might be overwritten.
      if (advRef) {
        postscribe(advRef.current, pageContent);
      }
    } else {
      console.log('Failed to fetch content from Panoraama');
    }

    setIsLoading(false);
  }

  return (
    <div className="panoraama-react-app">
      <div id="panoraama-content-react" ref={advRef}></div>
      {isLoading && <Spinner />}
    </div>
  );
};

export default PanoraamaContent;
